package pl.decks.chartjs.color

@Suppress("unused")
value class ChartColor private constructor(val cssValue: String) {

    companion object {
        fun rgba(r: Int, g: Int, b: Int, a: Float): ChartColor {
            require(r in 0..255) { "Red must be in 0..255" }
            require(g in 0..255) { "Green must be in 0..255" }
            require(b in 0..255) { "Blue must be in 0..255" }
            require(a in 0f..1f) { "Alpha must be in 0..1" }
            return ChartColor("rgba($r, $g, $b, $a)")
        }

        fun rgb(r: Int, g: Int, b: Int): ChartColor = rgba(r, g, b, 1f)

        fun hex(value: String): ChartColor {
            require(value.matches(Regex("^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$"))) {
                "Invalid hex color: $value"
            }
            return ChartColor(value)
        }
    }

    internal fun toChartJs() : dynamic = cssValue.asDynamic()
}
